/**
 * 右栏接口（背景 / 长期记忆 / 下一步）。
 * 只读服务端已落库的内容；失败抛错，不回退本机演示数据。
 */
import { apiGet, apiSend } from './http-client'

export interface MemoryRow { id: string; text: string; createdAt: string }
/** 自定义助手场景：设置中心维护，聊天页场景入口展示；instruction 只给回答模型参考 */
export interface SceneRow { id: string; name: string; greeting: string; instruction: string; questions: string[]; createdAt: string }
export interface SceneDraft { name: string; greeting: string; instruction: string; questions: string[] }
export interface PanelRoute { path: string; query: Record<string, string> }
export interface PanelAction {
  id: string
  title: string
  detail: string
  status: 'pending' | 'running' | 'done' | 'failed' | 'skipped'
  at: string | null
  kind: 'chat' | 'task' | 'approval'
  route: PanelRoute | null
}
export interface PanelThought { id: string; tag: string; text: string; at: string }
export interface AssistantPanel {
  background: {
    orgName: string
    legal: string
    period: string
    role: string
    perm: string
    exec: boolean
    appTotal: number | null
    appAvailable: string
    note: string | null
    error: string | null
  }
  memories: { items: MemoryRow[]; error: string | null }
  scope: {
    context: {
      businessLine: string
      currentNode: string
      objectNo: string
      bizNode: string
      relatedDocs: string
      org: string
      period: string
      scopeNote: string
      authority: string
    } | null
    error: string | null
  }
  actions: { upcoming: PanelAction[]; todos: { items: PanelAction[]; total: number }; history: PanelAction[]; error: string | null }
  thinking: { items: PanelThought[]; error: string | null }
}

export const assistantApi = {
  panel: (org?: string) => apiGet<AssistantPanel>('/api/assistant/panel', org ? { org } : undefined),
  memories: () => apiGet<MemoryRow[]>('/api/assistant/memories'),
  createMemory: (text: string) => apiSend<MemoryRow>('POST', '/api/assistant/memories', { text }),
  removeMemory: (id: string) => apiSend<{ deleted: boolean }>('DELETE', `/api/assistant/memories/${encodeURIComponent(id)}`),
  clearMemories: () => apiSend<{ cleared: number }>('DELETE', '/api/assistant/memories'),
  scenes: () => apiGet<SceneRow[]>('/api/assistant/scenes'),
  generateScene: (text: string) => apiSend<SceneDraft>('POST', '/api/assistant/scenes/generate', { text }),
  saveScene: (scene: Partial<SceneRow> & { name: string }) => apiSend<SceneRow>('POST', '/api/assistant/scenes', scene),
  removeScene: (id: string) => apiSend<{ deleted: boolean }>('DELETE', `/api/assistant/scenes/${encodeURIComponent(id)}`),
}
